import React, { useEffect, useState } from "react";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import CustomButtonOval from "../../components/form/CustomButtonOval";
import CustomButton from "../../components/form/CustomButton";
import { getModules } from "../../helpers/configRoutes/backend_helper";

const ModulesPermissions = ({ modal, setModal, validation }) => {
    const [modules, setModules] = useState([]);
    const [selected, setSelected] = useState(validation.values.modelsPermissions);

    useEffect(() => {
        const getModulesCatalog = async () => {
            const response = await getModules();
            if (response.status) {
                setModules(response.models);
            }
        };
        getModulesCatalog();
    }, []);

    const addModule = (item) => {
        if (selected.filter(res => res?.id === item?.id).length === 0) {
            setSelected([...selected, item]);
        } else {
            let newSelected = selected.filter(res => res?.id !== item?.id);
            setSelected(newSelected);
        }
    };

    const save = () => {
        validation.setFieldValue('addPermissions', true);
        validation.setFieldValue('modelsPermissions', selected);
        setModal({ ...modal, show: false });
    };

    return (
        <BaseModalAnimated modal={modal} setModal={setModal}>
            {/* Header */}
            <div className="px-6 pt-6">
                <h2 className="text-lg font-semibold text-cs-dark">
                    Module permissions
                </h2>
                <p className="mt-1 text-sm text-cs-muted">
                    Select one or more modules to assign permissions.
                </p>
            </div>

            {/* Modules grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 p-6">
                {modules.map((m, i) => {
                    const isSelected = selected.filter(res => res?.id === m?.id).length > 0;

                    return (
                        <CustomButtonOval
                            key={i}
                            onClick={() => addModule(m)}
                            className={`
                w-full
                text-sm
                ${isSelected
                                    ? 'bg-cs-primary text-white border-cs-primary-dark/40'
                                    : 'bg-cs-surface text-cs-dark border border-cs-border hover:bg-cs-bg-alt'}
              `}
                        >
                            {m.name}
                        </CustomButtonOval>
                    );
                })}
            </div>

            {/* Footer */}
            <div className="flex flex-col items-center gap-4 px-6 pb-6">
                <p className="text-sm text-cs-muted">
                    * You can choose multiple order types
                </p>

                <CustomButton
                    loading={modal.loading}
                    textLoad={modal.textLoad}
                    onClick={save}
                    className="w-full sm:w-1/2 lg:w-[30%]"
                >
                    {modal.textButton ?? 'Save Preferences'}
                </CustomButton>
            </div>
        </BaseModalAnimated>
    );
};

export default ModulesPermissions;
